/** Unique brand symbol for translated strings */
declare const TranslatedStringBrand: unique symbol;

/**
 * Branded type for internationalized strings.
 * Only strings from gettext functions will have this type.
 * Regular strings cannot be assigned to TranslatedString without explicit casting.
 *
 * @example
 * ```tsx
 * // ✓ Valid - from gettext
 * const translated: TranslatedString = gettext('Hello');
 *
 * // ✗ Invalid - raw string
 * const raw: TranslatedString = 'Hello'; // Type error!
 * ```
 */
export type TranslatedString = string & { readonly [TranslatedStringBrand]: never };

/**
 * Escape hatch to cast a raw string to TranslatedString.
 * Use sparingly - prefer gettext() for all user-facing strings.
 */
export function asTranslatedString(str: string): TranslatedString {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
  return str as TranslatedString;
}
